var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-pagename text-xs-center"},[_vm._v("Refill credit")]),_c('CashCreditForm',{attrs:{"action_text":1}}),_c('v-card',[_c('RefillCreditListTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }